module.exports = __webpack_public_path__ + "img/factor_a.b462d5c3.svg";